export default "__VITE_ASSET__77cfaffd__"